import React from 'react';
import PropTypes from 'prop-types';
import SvgIcon from '@adsk/bim360-matrix-react-svg-icon';
import IconButton from '@adsk/bim360-matrix-react-icon-button';
import Button from '@adsk/bim360-matrix-react-button';
import closeRoundedIcon from '@adsk/bim360-matrix-react-assets/close-rounded-icon.svg';
import i18n from '../../utils/i18n';

const FilterIndicator = props => {
  const {onClick, resetFilters} = props;

  return (
    <Button className="FilterIndicator" styleType={Button.StyleType.INLINE_LINK} onClick={onClick}>
      <span className="FilterIndicator__text">{i18n.t('filter.filterIsOn')}</span>
      <IconButton onClick={resetFilters} className="FilterIndicator__clear-filters">
        <SvgIcon height="14px" width="14px">
          {closeRoundedIcon}
        </SvgIcon>
      </IconButton>
    </Button>
  );
};

FilterIndicator.displayName = 'FilterIndicator';

FilterIndicator.propTypes = {
  onClick: PropTypes.func.isRequired,
  resetFilters: PropTypes.func.isRequired
};

export default FilterIndicator;
